import React from 'react';
import { LoadingOutlined } from '@ant-design/icons';
import './style.scss';

/**
 * CenterLoading component - it works as a loading spinner.
 * 
 * @returns {JSX.Element} The CenterLoading component.
 * @example
 *  <CenterLoading />
 */
function CenterLoading() {
    return (
        <div className="center-loading">
            <LoadingOutlined />
        </div>
    );
}

export default CenterLoading;
